
export const storageEnabled = () => {
    if (navigator.cookieEnabled) {
      return true;
    } else {
      return false;
    } 
}
